@let articles = data$ | async;

@if (!articles?.length) {
  <section class="flex justify-center">
    <div class="loader"></div>
  </section>
} @else {
  <section class="max-w-screen-2xl mx-auto">
    <div class="w-10/12 sm:w-9/12 lg:w-8/12 mx-auto mt-10 mb-3">
      @if (firstArticleData(); as firstArticle) {
        <div
          class="lg:flex cursor-pointer mainArticle"
          [routerLink]="firstArticle.slug"
        >
          <img
            src="{{ firstArticle.image }}"
            alt="Image"
            class="rounded-t-lg w-full lg:w-2/3 lg:rounded-t-none lg:rounded-l-lg object-cover"
          />
          <div
            id="content"
            class="bg-white flex flex-col p-8 lg:p-5 xl:py-14 xl:px-8 rounded-b-lg lg:w-1/3 lg:rounded-bl-none lg:rounded-r-lg"
          >
            <p class="date pb-2">{{ firstArticle.date | slice: 0 : 10 }}</p>
            <p class="mainTitle pb-2">
              {{ firstArticle.title | slice: 0 : 100 }}
              @if (firstArticle.title.length > 100) {
                <span>...</span>
              }
            </p>
            <p class="mainContent py-6">
              {{ firstArticle.preview | slice: 0 : 100 }}...
            </p>
            <span class="article">{{ "blog.article" | translate }}</span>
          </div>
        </div>
      }
      <div class="flex flex-wrap justify-between mt-20">
        @for (article of articles | slice: 1 : 7; track article.id) {
          <app-blog-item [data]="article"> </app-blog-item>
        }
      </div>
    </div>
    <app-subscribe [place]="'blog'"></app-subscribe>
    <div class="w-10/12 sm:w-9/12 lg:w-8/12 mx-auto">
      <div class="flex flex-wrap justify-between mt-20">
        @for (article of articles | slice: 7; track article.id) {
          <app-blog-item [data]="article"> </app-blog-item>
        }
      </div>
    </div>
  </section>
}
<app-try-demo></app-try-demo>
<router-outlet></router-outlet>
